import styled from 'styled-components';

import { ThemeProps } from 'types/theme';

import { spacing } from 'src/styles/spacing';
import { ShadowedContainer } from 'components/container';

export const LoginContainer = styled.div`
  ${({ theme }: ThemeProps): string => `
    height: 100vh;
    background-size: cover;
    background-repeat: no-repeat;
    background-position-x: center;
    background-position-y: center;
    align-items: flex-start;
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex: 1;
    @media ${theme.media_queries.mediaS} {
      min-height: 550px;
      align-items: center;
    }
    .login-box {
      max-width: 328px;
      ${spacing('m', 4)}
      ${spacing('p', 6)}
      @media ${theme.media_queries.mediaS} {
        overflow: hidden;
        max-width: 364px;
        ${spacing('my', 0)}
      }
      .login-form {
        max-width: 316px;
        .toqio-text-field {
          max-width: 280px;
          @media ${theme.media_queries.mediaS} {
            max-width: 316px;
          }
        }
        .logo {
          ${spacing('py', 2.5)}
          max-width: 100%;
          max-height: 80px;
          @media ${theme.media_queries.mediaS} {
            max-width: 200px;
          }
        }
        .login-button {
          width: 100%;
        }
        .forgot-password {
          width: 100%;
          max-width: 335px;
          justify-content: flex-start;
        }
      }
    }
  `}
`;

const getLoginShadowedContainer = ({ theme }: ThemeProps) => {
  return `
    background-color: ${theme.color.general.background};
  `;
};

export const StyledShadowedContainer = styled(ShadowedContainer)`
  background-color: ${({ theme }) => theme.color.general.background};
  ${getLoginShadowedContainer}
  flex: 1;
  display: flex;
  flex-direction: column;
  ${spacing('px', 4)}
`;

export const StyledLoginForm = styled.form`
    display: flex;
    flex: 1;
    flex-direction: column;
    max-width: 364px;
    justify-content: center;
    align-items: center;
`;
